import React from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Routes
} from 'react-router-dom'

import { AppRoutesWrapper } from 'components/AppRoutesWrapper'
import { AuthenticatedRoutes } from 'components/AuthenticatedRoutes'
import { AuthenticatedRoutesWrapper } from 'components/AuthenticatedRoutesWrapper'
import { UnauthenticatedRoutes } from 'components/UnauthenticatedRoutes'
import { UnauthenticatedRoutesWrapper } from 'components/UnauthenticatedRoutesWrapper'
import useAuth from 'hooks/use-auth'

const AppRoutes: React.FC = () => {
  const { session } = useAuth()
  const hasSession = Boolean(session.company_id)

  return (
    <Routes>
      {hasSession ? (
        <Route element={<AuthenticatedRoutesWrapper />}>
          <Route element={<AuthenticatedRoutes />} path="/*" />
        </Route>
      ) : (
        <Route element={<UnauthenticatedRoutesWrapper />}>
          <Route element={<UnauthenticatedRoutes />} path="/*" />
        </Route>
      )}
    </Routes>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppRoutesWrapper />}>
      <Route element={<AppRoutes />} path={'/*'} />
    </Route>
  )
)

const App: React.FC = () => <RouterProvider router={router} />

export default App
